<template>
  <div class="toplink_item">
    <li class="dropdown btndropdown">
      <a
        href="#"
        class="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
      >
        <i class="far fa-globe-americas llnav"></i>&nbsp;
        <span v-text="code" class="code"></span>&nbsp;
        <span class="caret"></span>
      </a>
      <ul class="dropdown-menu language" role="menu">
        <li v-for="(lang, index) in available" :key="index">
          <a
            @click="$i18n.locale = lang.languageCode; code = lang.languageCode; changeLang(lang.id)"
            :data-id="lang.id"
            :data-code="lang.languageCode"
            class="setLang"
          >{{ lang.languageName }}</a>
        </li>
      </ul>
    </li>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls], //for api redundant operations
  data() {
    return {
      code: null,
      id: null,
      available: [],
      langs: ["en", "fr", "es"]
    };
  },
  computed: {
    ...mapState(["host", "session"]),
    locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    async getUserLanguage() {
      const response = await this.getApi("/api/v1/langs/current");
      this.code = response.code;
      this.id = response.id;
      this.$i18n.locale = response.code;
    },
    async getAvailable() {
      const response = await this.getApi("/api/v1/langs/available");
      this.available = response;
    },
    changeLang(id) {
      this.postApi("/api/v1/langs/current", { languageId: id });
    },
    setCurrentLocale(locale) {
      switch(locale) {
        case 'es': this.$store.dispatch('setCurrentLocale', 'es-ES'); break;
        case 'fr': this.$store.dispatch('setCurrentLocale', 'fr-FR'); break;
        default: this.$store.dispatch('setCurrentLocale', 'en-US');
      }
    }
  },
  created: function() {
    this.getUserLanguage();
    this.getAvailable();
  },
  mounted() {
    this.setCurrentLocale(this.locale);
  },
  watch: {
    locale(newVal) {
      this.setCurrentLocale(newVal);
    }
  }
};
</script>


<style scoped>
span.code {
  text-transform: uppercase;
  color: var(--v-lighten-base);
}
.dropdown-menu > li > a {
  color: var(--v-lighten-base);
}
.dropdown-menu.language > li > a.setLang {
    color: var(--v-primary-darken2) !important;
}
.dropdown-menu.language>li>a:hover {
    /*color: #262626;*/
    text-decoration: none;
    background-color: transparent;
    font-weight: bold;
}
@media screen and (max-width: 1024px){
  ul.dropdown-menu {
    right: 0;
    left: auto;
  }
}
</style>